import { PropTypes } from 'prop-types';
import moment from 'moment';
import React from 'react';
import { injectIntl } from 'react-intl';
import { FilterPlacement, PageFilters } from '../../../core/components/PageFilters';
import DetergentCostPerCar from '../../../core/components/DetergentCostPerCar';
import DetergentLevels from '../../../core/components/DetergentLevels';

const toFilterDate = (value) => {
  if (!value) return null;
  const date = moment(value);
  return date.isValid() ? date.toDate() : null;
};

const DetergentCharts = ({ intl, detergents, chartData, asOfDateProps }) => {
  const { fromDate, untilDate, setFromDate, setUntilDate } = asOfDateProps;
  const filterConfigs = React.useMemo(
    () => [
      {
        id: 'costPerCarDateRange',
        type: 'dateRange',
        name: intl.formatMessage({ id: 'date' }),
        placement: FilterPlacement.Chiclet,
        defaultVisible: true,
        icon: <i className="uil uil-calendar-alt" />,
        startDate: toFilterDate(fromDate),
        endDate: toFilterDate(untilDate),
        native: true,
        onChange: ([startDate, endDate]) => {
          setFromDate(startDate ? moment(startDate) : fromDate);
          setUntilDate(endDate ? moment(endDate) : untilDate);
        },
      },
    ],
    [fromDate, intl, setFromDate, setUntilDate, untilDate]
  );

  return (
    <React.Fragment>
      <div className="col-sm-6">
        <div className="filters-actions-container mb-3">
          <PageFilters filters={filterConfigs} maxChicletFilters={1} />
        </div>
        <DetergentLevels data={detergents} />
      </div>
      <div className="col-sm-6">
        <h5>{intl.formatMessage({ id: 'costPerCar' })}</h5>
        <DetergentCostPerCar data={chartData} />
      </div>
    </React.Fragment>
  );
};

DetergentCharts.propTypes = {
  intl: PropTypes.shape({}).isRequired,
  detergents: PropTypes.arrayOf(PropTypes.object),
  chartData: PropTypes.arrayOf(PropTypes.object),
  asOfDateProps: PropTypes.shape({}).isRequired,
};

export default injectIntl(DetergentCharts);
